const KNOWLEDGE_BASE_FILE_REFERENCE_PREFIX = 'knowledgeBaseFile:';

export function isKnowledgeBaseFile(props: { fileReference: string }): boolean {
  const { fileReference } = props;
  return fileReference.startsWith(KNOWLEDGE_BASE_FILE_REFERENCE_PREFIX);
}

export function convertToKnowledgeBaseFileIdOrUndefined(props: {
  fileReference: string;
}): string | undefined {
  const { fileReference } = props;
  if (!isKnowledgeBaseFile({ fileReference })) {
    return;
  }
  return fileReference.replace(KNOWLEDGE_BASE_FILE_REFERENCE_PREFIX, '');
}

export function convertToFileReference(props: { knowledgeBaseFileId: string }): string {
  const { knowledgeBaseFileId } = props;
  return `${KNOWLEDGE_BASE_FILE_REFERENCE_PREFIX}${knowledgeBaseFileId}`;
}
